import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";

export function useServerTime() {
  const q = useQuery({ queryKey: ["server-time"], queryFn: async () => (await api.get("/time")).data, staleTime: 60_000 });
  return q.data || null;
}
